import { useState, useEffect } from 'react';
import AdjustOutlined from '@mui/icons-material/AdjustOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useLocation } from 'react-router-dom';
import { useGlobalStore } from 'store/globalStore';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { CRUD_STATES } from 'constants/app';
import { useNotification } from 'hooks/useNotification';

function MenuSteps(props) {
  const { onSubmit, viewFields } = props;
  const [steps, setSteps] = useState([]);
  const location = useLocation();
  const { isLoading, activeStep, setActiveStep } = useAppProviderStore();
  const { setNotify } = useNotification();
  const { isExistVideo } = useGlobalStore();

  const renderIcons = (activeStep, index) => {
    if (activeStep === index + 1) {
      return (
        <>
          <AdjustOutlined className="icon-stepper step-active" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider"></div>
          )}
        </>
      );
    } else if (activeStep > index) {
      return (
        <>
          <CheckCircleOutlineOutlinedIcon className="icon-stepper step-active" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider-active"></div>
          )}
        </>
      );
    } else {
      return (
        <>
          <AdjustOutlined className="icon-stepper" />
          {index + 1 !== props.steps.length && (
            <div className="menu-step-divider"></div>
          )}
        </>
      );
    }
  };

  useEffect(() => {
    setSteps(props.steps);
  }, [props.steps, props.activeStep]);

  const handleClick = async step => {
    if (isExistVideo !== undefined) {
      if (location?.state?.action === CRUD_STATES.VIEW || viewFields) {
        if (!isLoading) {
          setActiveStep(step.id);
        }
      } else {
        if (
          location?.state?.action === CRUD_STATES.CREATE ||
          location?.state?.action === CRUD_STATES.EDIT
        ) {
          onSubmit();
        }
        if (!isLoading) {
          setActiveStep(step.id);
        }
      }
    } else {
      setNotify({
        isOpen: true,
        message:
          'Mídia não identificada, para avançar insira a mídia primeiro!',
        type: 'info',
        title: 'Atenção!',
      });
      // return;
    }

    // if (step.id === 6) {
    //   let path = `/admin/contents/${params?.id}/versions/${params?.version}`;
    //   let response = await getVideoById(getValues('id'), getValues('version'));
    //   let suggestionResponse = await getVideoById(path, auth, setAuth,setIsLoading,setNotify);
    // }
  };

  return (
    <ul className="menu_step" id="menu-step">
      {steps.map((step, index) => (
        <li
          className="menu_step-item"
          id={`menu-step-${index}`}
          // className={`${activeStep === 7
          //   ? "menu_step-item disabled-menu"
          //   : "menu_step-item"
          //   }`}
          key={step.label}
          onClick={() => handleClick(step)}>
          <div className="menu-step-item-divider">
            {renderIcons(activeStep, index)}
          </div>
          <div className="item-content">
            <span
              className={`${
                activeStep === index + 1
                  ? 'menu_step-item-title-active'
                  : 'menu_step-item-title'
              }`}>
              {step.label}
            </span>
            <div
              className={`${
                activeStep === index + 1
                  ? 'step-description-active'
                  : 'step-description'
              }`}>
              {step.description}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default MenuSteps;
